import type { Input as ButtonInput } from "../evo-button/index.marko";
import type { AttrClass } from "node_modules/marko/tags-html";
import s from "./style.module.css";
export interface Input {
    headline?: Marko.AttrTag<Marko.HTML.H2>;
    body?: Marko.AttrTag<Marko.HTML.P>;
    cta?: Marko.AttrTag<ButtonInput>;
    align?: "center" | "left";
    class?: AttrClass;
}

<const/{ headline, body, cta, align = "center", class: className }=input>

<div class=[s.container, className] data-align=align>
    <div class=s.text>
        <if=headline>
            <h2>
                <${headline.content}/>
            </h2>
        </if>
        <if=body>
            <p>
                <${body.content}/>
            </p>
        </if>
    </div>
    <if=cta>
        <evo-button ...cta/>
    </if>
</div>
